import { Box } from "@mui/material";
import { useEffect, useState } from "react";

import sanitizeHtml from "sanitize-html";

export default function NoteMessage({
  note,
}: {
  note: { when: number; who: string; body: string };
}) {
  const [cleanHtml, setCleanHtml] = useState<string>();

  useEffect(() => {
    const withAnchors = (note.body || "").replace(
      /\b(https|http)?:\/\/\S+/gi,
      '<a href="$&" target="_blank" rel="noreferrer">$&</a>'
    );

    const clean = sanitizeHtml(withAnchors, {
      allowedTags: ["b", "i", "em", "strong", "a"],
      allowedAttributes: {
        a: ["href", "target", "rel"],
      },
    });
    setCleanHtml(clean);
  }, [note]);

  return (
    <>
      <div className="flex gap-4 px-4">
        <div>{note.who}</div>
        <div className="ml-auto">
          {new Date(note.when).toLocaleDateString()}{" "}
          {new Date(note.when).toLocaleTimeString()}
        </div>
      </div>
      {cleanHtml ? (
        <Box
          className="font-bold px-4"
          sx={{
            a: {
              color: "var(--realbrave-orange)",
              display: "inline-block",
              position: "relative",
              textDecoration: "underline",
            },
          }}
          dangerouslySetInnerHTML={{ __html: cleanHtml }}
        ></Box>
      ) : null}
    </>
  );
}
